<template>
    <div class="discover-more">
        <JsonLd :json="jsonld" />
        <section class="section01">
            <div class="text sp_padding">
                <div class="headline">Discover More</div>
                <div class="title">International reporters<br> experience Japan Heritage</div>
                <div class="lead">
                    <p>The best way to fully appreciate the culture and history behind each Japan Heritage is to actually go there and experience it for yourself.</p>

                    <p>In this section, we asked reporters and writers from foreign media to visit Japan Heritage sites and share their experiences in their respective outlets. This time, japan-guide.com, a leading English travel website focusing on Japan, took  us up on our offer. Which Japan Heritage site did they visit?</p>
                </div>
            </div>
            <div class="layout-bg">
                <div class="movie">
                    <video-player :options="videoOptions"></video-player>
                </div>
            </div>
        </section>
        <section class="section02">
            <div class="group_title">
                <div class="inner">
                    <div class="text sp_padding">
                        <div class="headline">Discover More  No. 1</div>
                        <div class="title">Experience the days of old in Tomonoura by the sea</div>
                        <div class="lead">
                            <p> A 2-day itinerary in a historical port town</p>
                        </div>
                    </div>
                    <div class="group_reporters sp_padding">
                        <div class="title">Reporters visiting Japan Heritage site</div>
                        <div class="group_card">
                            <div class="card">
                                <div class="img"><img src="./../../assets/discover_more/reporter01.png" alt=""></div>
                                <div class="text">
                                    <div class="name">Raina Ong</div>
                                    <div class="introduction">japan-guide.com<br> editor,writer, photographer</div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="img"><img src="./../../assets/discover_more/reporter02.png" alt=""></div>
                                <div class="text">
                                    <div class="name">Thomas Rönnlund</div>
                                    <div class="introduction">japan-guide.com<br>videographer</div>
                                </div>
                            </div>
                        </div>
                        <div class="group_information">
                            <div class="img"><img src="./../../assets/discover_more/logo_japanguide.png" alt=""></div>
                            <div class="text">A Japan travel guide geared towards English speakers, particularly in Europe, the US, and Australia.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="group">
                    <div class=" layout-bg">
                        <div class="image">
                            <img src="./../../assets/discover_more/img01.jpg" alt="">
                            <figcaption  class="sp_padding"><i>Joyato</i> lantern at dusk</figcaption>
                        </div>
                    </div>
                    <div class="text sp_padding">
                        The early-modern port town of Tomonoura, Hiroshima Prefecture, is the setting of films, dramas, and anime, and it’s no wonder — the historic houses and surrounding natural landscape create a stunning contrast. Visiting this picturesque town, we were particularly struck by the beauty of the <i>joyato</i> lantern soon after sunset.
                    </div>
                </div>
                <div class="group">
                    <div class="img">
                        <img src="./../../assets/discover_more/img02.jpg" alt="">
                        <figcaption class="sp_padding">Townscape around the port area</figcaption>
                    </div>
                    <div class="text sp_padding">
                        In Tomonoura, we savored <i>taimeshi</i> (sea bream rice) and other delectable dishes using the best of local ingredients, and visited sites steeped in centuries of history such as the Ota Residence, Fukuzenji Temple, and Ioji Temple.
                    </div>
                </div>
                <div class="group">
                    <div class="layout-2column">
                        <div class="img">
                            <img src="./../../assets/discover_more/img03_01.jpg" alt="">
                            <figcaption class="sp_padding">Our <i>taimeshi</i> lunch</figcaption>
                        </div>
                        <div class="img">
                            <img src="./../../assets/discover_more/img03_02.jpg" alt="">
                            <figcaption class="sp_padding">Ota Residence</figcaption>
                        </div>
                    </div>
                    <div class="text sp_padding">
                        At Ioji Temple, we climbed up the 583 steps up to its Taishiden hall, and used a drone camera to capture the spectacular view of this port town in its entirety.
                    </div>
                </div>
                <div class="group">
                    <div class="layout-2column">
                        <div class="img">
                            <img src="./../../assets/discover_more/img04_01.jpg" alt="">
                            <figcaption class="_pc">Filming using a drone from Ioji Temple</figcaption>
                        </div>
                        <div class="img">
                            <img src="./../../assets/discover_more/img04_02.jpg" alt="">
                        </div>
                    </div>
                    <div class="text sp_padding">
                        Experiencing this Japan Heritage firsthand, we felt that Tomonoura is an attractive destination full of beauty, tranquility, and delicious dishes to satisfy both soul and stomach.
                    </div>
                </div>
                <div class="auther sp_padding">Written by: media tour crew accompanying japan-guide.com</div>
            </div>
            <a href="https://www.japan-guide.com/ad/tomonoura-by-the-sea/" target="_blank" rel="noopener noreferrer">
                <div class="card_link">
                    <div class="text">
                        <div class="headline">japan-guide.com article</div>
                        <div class="title">Experience the days of old in Tomonoura by the sea</div>
                        <div class="lead">A 2-day itinerary in a historical port town</div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </a>
            <a href="https://www.youtube.com/watch?v=RLPgq3m02Hw&t=1s" target="_blank" rel="noopener noreferrer">
                <div class="card_link">
                    <div class="text">
                        <div class="headline">japan-guide.com video</div>
                        <div class="title">Experience the days of old in Tomonoura by the sea</div>
                        <div class="lead">A 2-day itinerary in a historical port town</div>
                    </div>
                    <div class="arrow"></div>
                </div>
            </a>
        </section>
        <section class="section04">
            <div class="inner">
                <h2>Other Articles</h2>
                <ul>
                    <li>
                        <router-link :to="{name: 'DiscoverMore2'}" target="_blank" rel="noopener noreferrer">
                            <div class="img"><img src="./../../assets/discover_more2/Sake.jpg" alt=""></div>
                            <div class="text">
                                <div class="headline">Exploring the sake regions of Itami and Nada</div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </section>
        <section class="section03">
            <div class="inner">
                <h2>Related links</h2>
                <ul>
                    <li>
                        <a href="https://www.japan.travel/japan-heritage/popular/17aa9650-6f70-4ba9-84bf-41fe6c9f5434" target="_blank" rel="noopener noreferrer">
                            <div class="img"><img src="./../../assets/discover_more/related-link01.jpg" alt=""></div>
                            <div class="text">
                                <div class="headline">More on this Japan Heritage</div>
                                <div class="title">The Beautiful Old Port Town of Tomonoura</div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
import JsonLd from "@/components/JsonLd/JsonLd.vue";
export default {
    name: "DiscoverMore",
    components: {JsonLd, VideoPlayer},
    created: function() {
        document.title = 'Discover More | Japan Heritage Official Site'
    },
    data: function () {
        return {
            videoOptions: {
                controls: true,
                preload: 'none',
                fluid: true,
                muted: false,
                poster: 'https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/DiscoverMore.jpg',
                sources: [
                    {
                        src: "https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/streaks/discover_more.m3u8",
                    }
                ],
            },
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "International reporters experience Japan Heritage",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../assets/index/top/tomonoura04.jpg')
                ],
                "datePublished": "2024/11/14",
                "dateModified": "2024/11/14",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        }
    },
}
</script>

<style  src="./DiscoverMore.scss" lang="scss" scoped>
body {
    font-family: 'Marcellus', serif !important;
}
</style>
